import axios from './axios'
import qs from 'qs';
let userBastUrl = '/api/amazonProduct/';
/**
 *
 *
 */
export default {
  listAmazonProductGroupByAsin(data) {
    return axios.get(userBastUrl + 'listAmazonProductGroupByAsin', {
      params: data
    });
  },
  editAmazonProduct(data) {
    return axios.post(userBastUrl + 'editAmazonProduct', data, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    });
  },
  editAmazonProductForAsin(data) {
    return axios.post(userBastUrl + 'editAmazonProductForAsin', data, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    });
  },
  editAmazonProductPrice(data) {
    return axios.post(userBastUrl + 'editAmazonProductPrice', data, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    });
  },
  getExchangeRate(data) {
    return axios.get(userBastUrl + 'getExchangeRate', {
      params: data
    });
  },
  editExchangeRate(data) {
    return axios.post(userBastUrl + 'editExchangeRate', qs.stringify(data));
  },
  updateAmazonProductPrice(data) {
    return axios.post(userBastUrl + 'updateAmazonProductPrice', qs.stringify(data));
  }
}
